<section id="plp-srlp-bottom-pagination" class="bottom-pagination_container hmf-mt-s hmf-mt-m-m">
  <div class="hmf-display-flex hmf-align-items-center hmf-justify-content-flex-end">
    @if (currentPageNumber > 1 ) {
      <button class="icon hmf-round-radius" type="button" (click)="decreasePageNumber()">
        <img src="assets/image/chevron-left.svg" alt="">
      </button>
    }
    @if (showLeftEllipsis) {
      <button class="bottom-pagination-number" type="button"
        tabindex="0" aria-label="First Page" (click)="lastNumberClick(1)">
        1
      </button>
      <span class="ellipsis">...</span>
    }
    @for (pageNumber of displayPages; track trackByFn(i, pageNumber); let i = $index) {
      <button class="bottom-pagination-number" type="button"
        tabindex="0" aria-label="Page Number {{pageNumber}}"
        [class.selected]="pageNumber === currentPageNumber"
        (click)="pageNumberCountClickEvent(pageNumber, i)">
        {{pageNumber}}
      </button>
    }
    @if (showRightEllipsis) {
      <span class="ellipsis">...</span>
      <button
        class="bottom-pagination-number"
        type="button" tabindex="0"
        aria-label="Last Page"
        (click)="lastNumberClick(totalPages)"
        >
        {{totalPages}}
      </button>
    }
    @if (currentPageNumber < totalPages) {
      <button class="icon hmf-round-radius" type="button" (click)="increasePageNumber()">
        <img src="assets/image/chevron-right.svg" alt="">
      </button>
    }
  </div>
</section>